import { apiClient } from '@/lib/api/api';
import { QueryParams } from '@/lib/api/types';

export abstract class APIService {
  protected basePath: string;

  protected constructor(basePath: string) {
    this.basePath = basePath;
  }

  protected get<T>(path = '', params?: QueryParams) {
    return apiClient.get<T>(`${this.basePath}${path}`, { params });
  }

  protected post<T>(path = '', body?: unknown) {
    return apiClient.post<T>(`${this.basePath}${path}`, body);
  }

  protected put<T>(path = '', body?: unknown) {
    return apiClient.put<T>(`${this.basePath}${path}`, body);
  }

  protected patch<T>(path = '', body?: unknown) {
    return apiClient.patch<T>(`${this.basePath}${path}`, body);
  }

  protected delete(path = '', params?: QueryParams) {
    return apiClient.delete(`${this.basePath}${path}`, { params });
  }
}
